import React from 'react';
import { Typography, Card } from 'antd';
import { CodeOutlined, BgColorsOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ProjectSelector = ({ 
  projects, 
  onProjectSelect, 
  type = 'dev', // 'dev' or 'des'
  isContentEmpty 
}) => {
  const Icon = type === 'dev' ? CodeOutlined : BgColorsOutlined;
  const colorScheme = type === 'dev' ? 'blue' : 'purple';

  return (
    <Card className="mb-6">
      <div className="text-center py-8">
        <Icon className={`text-4xl text-${colorScheme}-600 mb-4`} />
        <Title level={4} className={`text-${colorScheme}-800 mb-2`}>
          Select a Project to Edit
        </Title>
        <Text className={`text-${colorScheme}-600 mb-6 block`}>
          Choose a {type === 'dev' ? 'development' : 'design'} project from your portfolio to add {type === 'dev' ? 'detailed content' : 'a case study'}
        </Text>
        
        {/* Project Selection Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {projects.map((project) => (
            <Card
              key={project._id}
              className="cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => onProjectSelect(project)}
              cover={
                project.url ? (
                  <img
                    src={project.url}
                    alt={project.name}
                    className="h-32 object-cover"
                  />
                ) : (
                  <div className="h-32 bg-gray-100 flex items-center justify-center">
                    <Icon className={`text-2xl text-${colorScheme}-600`} />
                  </div>
                )
              }
              size="small"
            >
              <Card.Meta
                title={
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium truncate">{project.name}</span>
                    <span className={`bg-${colorScheme}-100 text-${colorScheme}-800 px-2 py-1 rounded text-xs ml-2`}>
                      {project.type}
                    </span>
                  </div>
                }
                description={
                  <div>
                    <Text className="text-xs text-gray-500 line-clamp-2">
                      {project.desc}
                    </Text>
                    <div className="mt-2">
                      <span className={`text-xs px-2 py-1 rounded ${
                        project.body && project.body.trim() && !isContentEmpty(project.body) ? 
                        'bg-green-100 text-green-800' : 
                        'bg-gray-100 text-gray-600'
                      }`}>
                        {project.body && project.body.trim() && !isContentEmpty(project.body) ? 
                          (type === 'dev' ? 'Has Content' : 'Has Case Study') : 
                          (type === 'dev' ? 'No Content' : 'No Case Study')
                        }
                      </span>
                    </div>
                  </div>
                }
              />
            </Card>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default ProjectSelector;